export const WorkspaceCapitalsStep = () => {
  return <div>Capitals</div>
}
